import { fetchWithAuth } from "../FetchWithAuth";
import { url } from "../url";

const BASE = `${url}/api/inbox`;

async function parseJson(response) {
  return response.json().catch(() => ({}));
}

export async function getConversations({ businessId, status, channel, assignedTo, search, page = 1, perPage = 30 }) {
  const q = new URLSearchParams();
  if (businessId) q.set("business_id", String(businessId));
  if (status) q.set("status", status);
  if (channel) q.set("channel", channel);
  if (assignedTo) q.set("assigned_to", String(assignedTo));
  if (search) q.set("search", search);
  q.set("page", String(page));
  q.set("per_page", String(perPage));
  const r = await fetchWithAuth(`${BASE}/conversations?${q}`, { method: "GET" });
  return parseJson(r);
}

export async function getConversation(id) {
  const r = await fetchWithAuth(`${BASE}/conversations/${id}`, { method: "GET" });
  return parseJson(r);
}

export async function getMessages(conversationId, { page = 1, perPage = 50 } = {}) {
  const r = await fetchWithAuth(
    `${BASE}/conversations/${conversationId}/messages?page=${page}&per_page=${perPage}`,
    { method: "GET" }
  );
  return parseJson(r);
}

export async function sendMessage(payload) {
  const r = await fetchWithAuth(`${BASE}/messages/send`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return parseJson(r);
}

export async function sendInternalNote(payload) {
  const r = await fetchWithAuth(`${BASE}/messages/internal-note`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return parseJson(r);
}

export async function assignConversation(conversationId, staffId) {
  const r = await fetchWithAuth(`${BASE}/conversations/${conversationId}/assign`, {
    method: "PATCH",
    body: JSON.stringify({ assigned_to: staffId }),
  });
  return parseJson(r);
}

export async function updateConversationStatus(conversationId, status, snoozedUntil) {
  const body = { status };
  if (snoozedUntil) body.snoozed_until = snoozedUntil;
  const r = await fetchWithAuth(`${BASE}/conversations/${conversationId}/status`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
  return parseJson(r);
}

export async function toggleStar(conversationId) {
  const r = await fetchWithAuth(`${BASE}/conversations/${conversationId}/star`, { method: "PATCH" });
  return parseJson(r);
}

export async function updateTags(conversationId, tags) {
  const r = await fetchWithAuth(`${BASE}/conversations/${conversationId}/tags`, {
    method: "PATCH",
    body: JSON.stringify({ tags }),
  });
  return parseJson(r);
}

export async function toggleAutoReply(conversationId) {
  const r = await fetchWithAuth(`${BASE}/conversations/${conversationId}/auto-reply`, { method: "PATCH" });
  return parseJson(r);
}

export async function suggestReply(conversationId) {
  const r = await fetchWithAuth(`${BASE}/ai/suggest-reply`, {
    method: "POST",
    body: JSON.stringify({ conversation_id: conversationId }),
  });
  return parseJson(r);
}

export async function detectIntent(conversationId) {
  const r = await fetchWithAuth(`${BASE}/ai/detect-intent`, {
    method: "POST",
    body: JSON.stringify({ conversation_id: conversationId }),
  });
  return parseJson(r);
}

export async function getTemplates({ channel } = {}) {
  const q = new URLSearchParams();
  if (channel) q.set("channel", channel);
  const r = await fetchWithAuth(`${BASE}/templates?${q}`, { method: "GET" });
  return parseJson(r);
}

export async function getChannelAccounts() {
  const r = await fetchWithAuth(`${BASE}/channel-accounts`, { method: "GET" });
  return parseJson(r);
}
